import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MassUseMerchantModel } from 'Pages/pp'

type MassUseMerchantState = {}

const massUseMerchantInitialState: MassUseMerchantState = {}

export namespace MassUseMerchantStateNS {
	export type CreateOne = PayloadAction<MassUseMerchantModel>
	export type DeleteOne = PayloadAction<MassUseMerchantModel>
}

export const massUseMerchantSlice = createSlice({
	name: 'massUseMerchant',
	initialState: massUseMerchantInitialState,
	reducers: {
		createOne: (state, action: MassUseMerchantStateNS.CreateOne) => {},
		deleteOne: (state, action: MassUseMerchantStateNS.DeleteOne) => {},
	},
})
